import { render, staticRenderFns } from "./UpSkillingGoals.vue?vue&type=template&id=5a1a69c8&"
import script from "./UpSkillingGoals.vue?vue&type=script&lang=js&"
export * from "./UpSkillingGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports